import type { ThemeDefinition } from './types';

export const koodookaLight: ThemeDefinition = {
  id: 'koodooka',
  name: 'Koodooka',
  description: 'Koodooka brand light theme — porcelain surfaces, ink typography, and terracotta accents',
  mode: 'light',
  tokens: {
    colorPrimary: '#A74432',
    colorPrimaryOnSidebar: '#A74432',
    colorPrimaryHover: '#BD523D',
    colorPrimaryActive: '#873425',
    colorPrimaryBg: '#F6E9E5',
    colorFocus: '#A74432',
    colorSecondary: '#66615D',
    colorAccent: '#C15B44',
    colorSuccess: '#1F7A55',
    colorWarning: '#A86D19',
    colorError: '#B73B3B',
    colorInfo: '#3E648F',
    colorBgBase: '#F6F5F2',
    colorBgContainer: '#FCFBF9',
    colorBgElevated: '#FFFFFF',
    colorBgSidebar: '#EFEEE9',
    colorText: '#171615',
    colorTextSecondary: '#66615D',
    colorTextTertiary: '#8A847E',
    colorTextOnChrome: '#24211F',
    colorTextInverse: '#FFFFFF',
    colorBorder: '#E1DED8',
    colorBorderSecondary: '#ECE9E4',
    boxShadow: '0 1px 2px rgba(20, 18, 16, 0.05), 0 8px 24px rgba(20, 18, 16, 0.035)',
    boxShadowSecondary: '0 18px 50px rgba(20, 18, 16, 0.10), 0 2px 8px rgba(20, 18, 16, 0.05)',
    glassBlur: '20px',
    glassOpacity: '0.88',
    glassContentOpacity: '0.96',
    glassModalOpacity: '0.90',
    glassSaturation: '125%',
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontFamilyHeading: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontFamilyDisplay: '"Instrument Serif", Georgia, serif',
    fontFamilyMono: '"SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Menlo, Consolas, monospace',
    fontSize: 14,
    fontSizeHeading: 22,
    borderRadius: 10,
    borderRadiusLG: 14,
    cardBorder: '#E1DED8',
    cardShadow: '0 1px 2px rgba(20, 18, 16, 0.05)',
  },
};

export const koodooka = koodookaLight;
